import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Rating } from "react-simple-star-rating";
import { Link } from "react-router-dom";

export const RepairShops = ({data , loading}) => {

  return loading ? (
    <Spinner />
  ) : data.length !== 0 ? (
    <div className="garageList">
      {data?.map((garage, q) => (
        <Link
          to={`/services/serviceItemDetails?${garage.id}`}
          className="garageItem"
        >
          <div className="garageInfo">
            <img src={garage.image} alt="" className="garageImg" />
            <div className="garageStats">
              <h3 className="garageTitle">{garage.name}</h3>
              <Rating ratingValue={garage.rate * 20} readonly={true} />
              <div>
                <img src="" alt="" />
                <span>
                  <i className="icon-market icons" />
                  {garage.type === "both" ? "خدمات سیار و ثابت" : "خدمات ثابت"}
                </span>
              </div>
            </div>
          </div>
          <div className="services">
            {garage.parent_services.map((item) => (
              <>
                <i className="icon-filters icons" />
                <span>{item.title}</span>
              </>
            ))}
          </div>
        </Link>
      ))}
    </div>
  ) : (
    <div className="noServiceFound">
      <i className="icon-times" />
      <span>تعمیرگاهی یافت نشد</span>
    </div>
  );
};
